
import { DomEditor } from '@wangeditor/core';
import { Node, Transforms } from 'slate';

function getTopicConfig(editor) {
  const { EXTEND_CONF } = editor.getConfig()
  const { topicConfig } = EXTEND_CONF;
  return topicConfig;
}

function topicPlugin(editor) {
  const { isInline, insertData, normalizeNode, insertText } = editor;
  const newEditor = editor;

  // 重写 isInline
  newEditor.isInline = (elem) => {
    const { type } = elem;

    if (type === 'topic') {
      return true;
    }

    return isInline(elem);
  };
  newEditor.insertText = t => {
    const elems = DomEditor.getSelectedElems(newEditor);
    const isSelectedVoidElem = elems.some((elem) => newEditor.isVoid(elem));
    if (isSelectedVoidElem) {
      insertText(t);
      return;
    }

    if(!getTopicConfig(newEditor)) {
      insertText(t);
      return;
    }
    // topic 相关配置
    const { showModal, hideModal } = getTopicConfig(newEditor);
    const topicElemList = editor.getElemsByType('topic');
    
    const { focus, anchor } = editor.selection;
    const currentNode = editor.children[focus.path[0]]?.children[focus.path[1]];
    const offset = focus.offset;
    if (currentNode?.type === 'topic') {
      const text = currentNode.children[0]?.text;
      if(offset < text.length) { //话题中间插入内容
        if (t !== '#') {
          insertText(t);
        } else {
          // 话题中间插入#，话题内容变短
          const leftText = text.slice(0, offset);
          const rightText = text.slice(offset);
          editor.select({
            anchor: {
              ...anchor,
              offset: offset + rightText.length,
            },
            focus: {
              ...focus,
              offset: offset - leftText.length
            },
          });
          editor.deleteFragment();
          if (leftText === '#') {
            // 在第一个#后面添加#，截取后半部分为新话题
            editor.insertFragment([{ text: leftText }]);
            const topicNode = {
              type: 'topic',
              children: [{ text: `${t}${rightText}` }],
            };
            editor.insertNode(topicNode)
          } else {
            // 截取前半部分为新话题
            const topicNode = {
              type: 'topic',
              children: [{ text: `${leftText}${t}` }],
            };
            editor.insertNode(topicNode)
            editor.insertFragment([{ text: rightText }]);
          }
        }
      } else {
        // 话题#后面插入内容
        editor.insertFragment([{ text: t }]);
      }
      return;
    }
    const text = currentNode?.text?.slice(0, focus.offset);
    if (t === "#" && !topicElemList.length) {
      if (text.indexOf('#') !== -1 && text.indexOf('#') !== text.length - 1) { //出现#fdsf#
        const leftText = text.slice(0, text.indexOf('#'));
        const rightText = text.slice(text.indexOf('#'));
        editor.select({
          anchor: {
            ...anchor,
            offset: 0,
          },
          focus: {
            ...focus,
          },
        });
        editor.deleteFragment();
        editor.insertFragment([{ text: leftText }]);
        const topicNode = {
          type: 'topic',
          children: [{ text: rightText + t }],
        };
        editor.insertNode(topicNode)
        return;
      }
      setTimeout(() => {
        // 展示 modal （异步，以便准确获取光标位置）
        if (showModal) showModal(newEditor);

        // 监听，隐藏 modal（异步，等待 modal 渲染后再监听）
        setTimeout(() => {
          function _hide() {
            if (hideModal) hideModal(newEditor);
          }
          newEditor.once("fullScreen", _hide);
          newEditor.once("unFullScreen", _hide);
          newEditor.once("scroll", _hide);
          newEditor.once("modalOrPanelShow", _hide);
          newEditor.once("modalOrPanelHide", _hide);

          function hideOnChange() {
            if (newEditor.selection != null) {
              _hide();
              newEditor.off("change", hideOnChange); // 及时解绑
            }
          }
          newEditor.on("change", hideOnChange);
        });
      });
    }

    // 非 '#' 则执行默认行为
    insertText(t);
  }

  // 重写 insertData ，粘贴插入链接
  newEditor.insertData = (data) => {
    insertData(data);
  };

  newEditor.normalizeNode = ([node, path]) => {
    const type = DomEditor.getNodeType(node);
    const str = Node.string(node);
    if (type !== 'topic') {
      // 未命中 link ，执行默认的 normalizeNode
      return normalizeNode([node, path]);
    }

    if (str === '') {
      return Transforms.removeNodes(newEditor, { at: path });
    }
    return normalizeNode([node, path]);
  };

  // 返回 editor ，重要！
  return newEditor;
}

export default topicPlugin;
